module.exports = "<div class=\"heyground-slider\">\n  <div class=\"swiper-container swiper-main-slider\">\n    <div class=\"swiper-wrapper\"></div>\n    <div class=\"swiper-pagination\"></div>\n    <div class=\"swiper-button-wrap\">\n      <div class=\"swiper-button-prev\"></div>\n    </div>\n    <div class=\"swiper-button-wrap\">\n      <div class=\"swiper-button-next\"></div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/slider/slider.component.html
// module id = 1088
// module chunks = 0